import { Globe, Layers, Database, Bot, Search } from "lucide-react";

export const services = [
  {
    id: "website-design",
    index: "01",
    icon: Globe,
    title: "Website Designing & Development",
    short: "Website Design",
    menuDesc: "Business sites, web apps and e-commerce engineered to convert.",
    copy: "A site engineered to convert — from business websites to full custom builds.",
    headline: "Your Website Is the First System a Prospective Client Interacts With.",
    sectionCopy: "We design and build it to convert — not just to look good.",
    capabilities: [
      "Business Websites",
      "Web Applications",
      "E-commerce",
      "Website Redesign",
      "Custom-Built Websites",
      "WordPress Websites",
    ],
    cta: "Need a website that does more than look good? Let's talk.",
  },
  {
    id: "saas-development",
    index: "02",
    icon: Layers,
    title: "SaaS Development",
    short: "SaaS",
    menuDesc: "Custom platforms and software built around how you actually work.",
    copy: "Custom software and platforms built around how your business actually works.",
    headline: "When Off-the-Shelf Software Doesn't Fit, Build the Software That Does.",
    sectionCopy:
      "From internal tools to full SaaS products — scoped, designed and engineered by one team.",
    capabilities: [
      "Custom Software",
      "SaaS Platforms",
      "Admin Panels",
      "Customer Portals",
      "Internal Business Systems",
    ],
    cta: "Have an idea for a platform or internal tool? Let's scope it.",
  },
  {
    id: "crm-systems",
    index: "03",
    icon: Database,
    title: "CRM & Business Systems",
    short: "CRM",
    menuDesc: "One system for leads, sales, your team and every report.",
    copy: "One system for leads, sales, your team, and every report you need.",
    headline: "Leads, Sales, Your Team and Reporting — In One System.",
    sectionCopy:
      "Stop losing leads between tools. A custom system that matches your actual pipeline.",
    capabilities: [
      "Custom CRM",
      "Lead Management",
      "Sales Pipelines",
      "Customer Management",
      "Team Management",
      "Employee Systems",
      "Dashboards",
      "Reports",
      "Role-Based Systems",
    ],
    cta: "Tired of leads falling through the cracks? Let's fix that.",
  },
  {
    id: "ai-automation",
    index: "04",
    icon: Bot,
    title: "AI & Automation",
    short: "AI & Automation",
    menuDesc: "Agents and workflows that remove repetitive work from your team.",
    copy: "Agents and workflows that remove the repetitive work from your team's day.",
    headline: "Take Repetitive Work Off Your Team's Plate.",
    sectionCopy:
      "Practical AI — wired into your real processes, not demos. If your team does it every week, we can probably automate it.",
    capabilities: [
      "AI Automation",
      "AI Agents",
      "Chatbots",
      "Workflow Automation",
      "Document Processing",
      "Lead Automation",
      "AI-Powered Reporting",
      "Email Automation",
      "Business Process Automation",
      "Automation Platforms",
    ],
    cta: "Still doing this manually every week? There's a better way.",
  },
  {
    id: "seo",
    index: "05",
    icon: Search,
    title: "Website SEO",
    short: "SEO",
    menuDesc: "Technical, on-page and growth SEO built in from day one.",
    copy: "Built to be found — technical, on-page and growth SEO from day one.",
    headline: "A Beautiful Website Nobody Finds Is a Missed System.",
    sectionCopy: "We build SEO into the foundation, not bolt it on after.",
    capabilities: [
      "Technical SEO Audits",
      "On-Page Optimization",
      "Site Speed",
      "Core Web Vitals",
      "Keyword & Content Strategy",
      "Local SEO",
      "Structured Data / Schema",
      "Monthly Performance Reporting",
    ],
    cta: "Built a great site nobody's finding? Let's fix your visibility.",
  },
];
